///include /assets/js/app/p/brand.js
///include /assets/js/app/s/form-guard.js

class SContactPage {
    init() {
        this.view = new Vue({
            el: ".vue-wrapper",
            name: "contact-page",
            data() {
                const vue = this;
                return {
                    brand: null,
                    settings: SharedSettings.inst,
                    name: '',
                    email: '',
                    message: '',
                    /** @type {?string} See FormGuard */
                    formNonce: null,
                    submitted: false,
                    status: {
                        sent: false,
                        errors: {
                            email: false,
                            name: false,
                            message: false
                        }
                    },
                    sendInProgress: false,
                    loading: true,
                }
            },
            computed: {
            },
            methods: {
                submitContactFormData(e){
                    var data = {
                        name: this.name,
                        email: this.email,
                        message: this.message,
                        [FormGuard.NONCE_FIELD]: this.formNonce,
                        // Read from the page: bots may fill it in without
                        // the events Vue would see.
                        [FormGuard.HONEYPOT_FIELD]: $("#contact_website").val(),
                    };

                    this.submitted = true;
                    this.sendInProgress = true;
                    $.ajax({
                        method: 'post',
                        url: `/a/stackContactForm`,
                        data: data
                    }).then(
                        (r) => {
                            this.status = Object.assign({},r);
                        },
                        () => {
                            this.status.sent = false;
                        }
                    ).always( () => {
                        this.sendInProgress = false;
                        // The nonce is used up, so get one for any retry
                        this.formNonce = null;
                        this.fetchFormNonce();
                    } );
                },
                fetchFormNonce() {
                    FormGuard.nonce("contact").then(nonce => this.formNonce = nonce);
                }
            },
            mounted() {
                this.fetchFormNonce();
                setTimeout( () => {
                    this.loading = false;
                }, 600 );
            },
            components: {
                shopNav: ShopNav,
            },
        })
    }
}
